

const setFiltersEventName = (filterName, isInModal = false) => {
    return isInModal ? `${filterName}_modal` : `${filterName}_page`;
};

export default setFiltersEventName;